<template>
	<div style="display: inline-block;">
		<van-popover v-model="actionShow" trigger="click" :actions="dropdowns" @select="select" placement="bottom-end">
			<template #reference>
				<van-button size="small" type="default" >更多</van-button>
			</template>
		</van-popover>
		<!-- 			<van-action-sheet v-model="actionShow" :actions="dropdowns" @select="select" :close-on-popstate="true"
				:safe-area-inset-bottom="true" /> -->
	</div>
</template>
<script>
	export default {
		props: {
			formCreateInject: {
				type: Object,
				default: () => {
					return null
				}
			},
			dropdowns: {
				default: () => {
					return []
				}
			},
			data: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				actionShow: false
			}
		},
		created() {
			this.dropdowns.forEach((item)=>{
				item.text = item.name
			})

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		methods: {
			select(e) {

				this.$emit('select', {
					...e,
					data: this.data
				})
				this.actionShow = false
			}
		}
	}
</script>
